<form class="form-popup" [formGroup]="formGroup" #sanForm="ngForm">

    <div class="btn-group vcenter-right" role="group" aria-label="...">
      <a class="btn btn-default btn-sm" role="button" target="_blank" [routerLink]="printSAN()"  >Print</a>
    </div>

    <div class="table">
      <b>
        Arrivals and Departures on {{sanSDN.day | date: 'MM/dd/yyyy'}}
      </b>

      <aims-form [editable]="true" [header]="'Arrivals'" [spaceRows]="true">
        <table id="san01" class="center">
          <tr>
            <th width="400px">
              <b><u>Name</u></b>
            </th>
            <th width="100px">
              <b><u>Org</u></b>
            </th>
            <th width="100px">
              <b><u>Site</u></b>
            </th>
            <th width="15%">
              <b><u>Confirm</u></b>
            </th>
            <th width="15%">
              <b><u>Action Required</u></b>
            </th>
          </tr>
          <tr *ngFor="let s of sanSDN.items">
            <!--{{ s | json }}-->
            <ng-container *ngIf="checkArrivalTravel(sanSDN.day, s)">
              <ng-container *ngIf="s.employeeId > 0">
                <td width="400px">
                  {{s.employeeId | getText:'employeeId':'fullName':emps}}
                </td>
              </ng-container>
              <ng-container *ngIf="s.resourceId > 0">
                <td width="400px">
                  {{s.resourceId | getText:'resourceId':'fullName':resourceValues | async}}
                </td>
              </ng-container>
              <td width="100px">
                {{s.organization}}
              </td>
              <td width="100px">
                {{s.siteCode}}
              </td>
              <td width="15%">
                <button type="button"
                        [ngClass]="(checkConfirmedArrival(s)== true)? 'btn btn-primary btn-sm' : 'btn btn-default btn-sm'"
                        id="ConfirmArrival"
                        (click)="confirmArrival(sanSDN.day, s)"
                        [disabled]="m().isBefore(sanSDN.day, 'day')">
                  <i class="fas fa-thumbs-up"></i>
                </button>
              </td>
              <td width="15%">
                <button type="button"
                        [ngClass]="(checkConfirmedArrival(s) == false)? 'btn btn-primary btn-sm' : 'btn btn-default btn-sm'"
                        id="ActionRequiredArrival"
                        (click)="actionRequiredArrival(sanSDN.day, s)"
                        [disabled]="m().isBefore(sanSDN.day, 'day')">
                  <i class="fas fa-thumbs-down"></i>
                </button>
              </td>

            </ng-container>
          </tr>
        </table>

      </aims-form>

      <aims-form [editable]="true" [header]="'Departures'" [spaceRows]="false">
        <table id="san02" class="center">
          <tr>
            <th width="400px">
              <b><u>Name</u></b>
            </th>
            <th width="100px">
              <b><u>Org</u></b>
            </th>
            <th width="100px">
              <b><u>Site</u></b>
            </th>
            <th width="15%">
              <b><u>Confirm</u></b>
            </th>
            <th width="15%">
              <b><u>Action Required</u></b>
            </th>
          </tr>
          <tr *ngFor="let s of sanSDN.items">
            <ng-container *ngIf="checkDepartureTravel(sanSDN.day, s)">
              <ng-container *ngIf="s.employeeId > 0">
                <td width="400px">
                  {{s.employeeId | getText:'employeeId':'fullName':emps}}
                </td>
              </ng-container>
              <ng-container *ngIf="s.resourceId > 0">
                <td width="400px">
                  {{s.resourceId | getText:'resourceId':'fullName':resourceValues | async}}
                </td>
              </ng-container>
              <td width="100px">
                {{s.organization}}
              </td>
              <td width="100px">
                {{s.siteCode}}
              </td>
              <td width="15%">
                <button type="button"
                        [ngClass]="(checkConfirmedDeparture(s)== true)? 'btn btn-primary btn-sm' : 'btn btn-default btn-sm'"
                        id="ConfirmDeparture"
                        (click)="confirmDeparture(sanSDN.day, s)"
                        [disabled]="m().isBefore(sanSDN.day, 'day')">
                  <i class="fas fa-thumbs-up"></i>
                </button>
              </td>
              <td width="15%">
                <button type="button"
                        [ngClass]="(checkConfirmedDeparture(s) == false)? 'btn btn-primary btn-sm' : 'btn btn-default btn-sm'"
                        id="ActionRequiredDeparture"
                        (click)="actionRequiredDeparture(sanSDN.day, s)"
                        [disabled]="m().isBefore(sanSDN.day, 'day')">
                  <i class="fas fa-thumbs-down"></i>
                </button>
              </td>

            </ng-container>
          </tr>
        </table>

      </aims-form>
    </div>

</form>
